import {pageQuerySHA, minifiedPageQuery} from '../server/helpers/PageSiteQuery'
import logger from './logger';
export function fetchPageData (variables,url) {
    try{
        const requestUrl = url+'?extensions={"persistedQuery":{"version":1,"sha256Hash":'+JSON.stringify(pageQuerySHA)+'}}&variables='+JSON.stringify(variables)
        // Use `no-store` so the browser never serves page data from its private
        // (disk) cache. The shared CDN still serves this GET from its edge cache,
        // so origin load is unchanged - users just stop seeing stale
        // "200 OK (from disk cache)" responses.
        return fetch(requestUrl, { cache: 'no-store' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status} ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                if(data.errors) {
                    return {
                        "error": true
                    }
                } else {
                    return {
                        "data": data
                    }
                }
            })
            .catch(err => logger(`Page fetch error: ${err}`, "error"));
     }
     catch(err){
        logger(`Page fetch error: ${err}`, "error")
     }
  }